import { AuthService } from '@myosh/myosh-login'
// NOTE: Use the public RTK Query entrypoint, not deep /dist path (breaks with exports field)
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const TMS_API_SUFFIX = 'services/tms/v1'

export const resolveBasePath = () => {
  const clusterConfig = JSON.parse(localStorage.getItem('ClusterConfig') || '{}')
  if (clusterConfig.apiBaseUrl) {
    return `${clusterConfig.apiBaseUrl}${TMS_API_SUFFIX}`
  }

  return `${process.env.REACT_APP_API_BASE_URL}${TMS_API_SUFFIX}`
}

export const resolveApiKey = () => {
  const clusterConfig = JSON.parse(localStorage.getItem('ClusterConfig') || '{}')
  if (clusterConfig.apiKey) {
    return clusterConfig.apiKey
  }
  return `${process.env.REACT_APP_API_KEY}`
}

const baseQuery = () =>
  fetchBaseQuery({
    baseUrl: resolveBasePath(),
    prepareHeaders: headers => {
      const userState = JSON.parse(localStorage.getItem('UserState') || '{}')
      const schema = userState?.user?.currentSchema
      const idToken = userState?.tokens?.id_token

      if (idToken) {
        headers.set('authorization', `Bearer ${idToken}`)
      }
      if (schema) {
        headers.set('Myosh-Schema', schema)
      }
      headers.set('x-api-key', resolveApiKey())

      return headers
    }
  })

export const baseQueryWithReAuthAndUrlEncoding: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  // let encodedUrl
  // if (isObject(args) && args.url) {
  //   encodedUrl = { ...args, url: urlEncodeParams(args.url) }
  // } else if (isString(args)) {
  //   encodedUrl = urlEncodeParams(args)
  // } else {
  //   encodedUrl = args
  // }

  let result = await baseQuery()(args, api, extraOptions)

  // handle re-auth with refreshToken
  if (result.error) {
    if (result.error.status === 401) {
      const authService = new AuthService()
      const refreshAuth = await authService.signinSilent()
      if (refreshAuth.refresh_token) {
        const userState = JSON.parse(localStorage.getItem('UserState') || '{}')
        userState.tokens = {
          ...userState.tokens,
          id_token: refreshAuth.id_token,
          access_token: refreshAuth.access_token,
          refresh_token: refreshAuth.refresh_token,
          expires_at: refreshAuth.expires_at,
          auth_time: Date.now()
        }
        localStorage.setItem('UserState', JSON.stringify(userState))
        result = await baseQuery()(args, api, extraOptions)
      } else {
        authService.logout()
      }
    }
  }

  return result
}
